<sdps-divider variation="secondary"></sdps-divider>
<span id="subtitle">Transaction details</span>
<mm-banners *ngIf="!isIncoming" class="ach-funds-settlement-banner" [bannerText]="[achFundsSettlementBannerText]" [type]="'information'"
  data-testid="sa_achFundsSettlementBanner">
</mm-banners>
<form [formGroup]="StandingAuthDetailsFormGroup" id="transaction-details-container">
    <mm-banners *ngIf="hasATSSystemError" [bannerText]="[atsSystemErrorText]" [type]="'error'"></mm-banners>
    <mm-recurring-frequency-selector *ngIf="isRecurringAch" [parentForm]="StandingAuthDetailsFormGroup"
    [frequencyList]="this.achInfo.frequencyList" (frequencyChanged)="onFrequencyChanged($event)" [isAch]="isRecurringAch" class="big-bottom-spacer">
    </mm-recurring-frequency-selector>
  <div class="row">
    <mm-date-picker-control *ngIf="isRecurringAch" [parentForm]="StandingAuthDetailsFormGroup" [label]="completionDateLabelName" data-testid="completionDatePicker"
    formControlName="completionDate" [formControlValidators]="datePickerValidators" id="transactionDetailsAch_completionDatePicker" [id]="'completion-date-picker'"
    class="big-bottom-spacer" [minDate]="minDate" [defaultDate]="defaultProcessDate">
    </mm-date-picker-control>

    <div *ngIf="isRecurringAch" class="expectedWithdrawalDate">
      <div class="header" data-testid="expectedWithdrawalDateLabel">
        Expected withdrawal date
        <mm-tooltip [position]="'right'" [containsLink]="false"
          id="transactionDetailsAch_expectedWithdrawalDateTooltip">
          <tooltip-content>
            <div>{{expectedWithdrawalDateCopy}}</div>
          </tooltip-content>
          <tooltip-trigger-element>
            <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
          </tooltip-trigger-element>
        </mm-tooltip>
      </div>
      <span id="transactionDetailsAch_expectedWithdrawalDate" data-testid="expectedWithdrawalDate"
        class="withdrawalDate">
        {{withdrawalDate$ | async | date : 'MM/dd/yyyy'}}</span>
    </div>
    <div *ngIf="isIncoming && isRecurringAch" class="fundsAvailableToTrade">
      <div class="header">
        Funds available to trade
        <mm-tooltip [position]="'right'" [containsLink]="false" id="saDetailsAch_fundsAvailableToTradeTooltip">
          <tooltip-content>
            <div>{{fundsAvailableToTradeCopy}}</div>
          </tooltip-content>
          <tooltip-trigger-element>
            <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
          </tooltip-trigger-element>
        </mm-tooltip>
      </div>
      <span id="saDetailsAch_fundsAvailableToTrade" data-testid="saDetailsAch_fundsAvailableToTrade" class="completionDate">
        {{fundsAvailableToTrade$ | async | date : 'MM/dd/yyyy'}}</span>
    </div>
  </div>

    <mm-date-picker-control *ngIf="showSecondCompletionDate" class="big-bottom-spacer" [parentForm]="StandingAuthDetailsFormGroup"
    [label]="secondCompletionDateLabelName"
    [formControlValidators]="endDateValidators" [id]="'ach-end-date-picker'"
    id="transactionDetailsAch_secondCompletionDate" formControlName="secondProcessDate" data-testid="secondCompletionDatePicker">
    </mm-date-picker-control>

    <mm-date-picker-control class="big-bottom-spacer" [parentForm]="StandingAuthDetailsFormGroup"
    [label]="endDateLabelName" [disableWeekends]="!isRecurringAch" [showOptionalLabel]="true"
    [formControlValidators]="endDateValidators" [id]="'ach-end-date-picker'"
    id="transactionDetailsAch_endDate" formControlName="endDate" data-testid="endDatePicker">
    </mm-date-picker-control>

  <div class="row">
    <mm-amount-field *ngIf="isRecurringAch && isIra && isIncoming" [parentForm]="StandingAuthDetailsFormGroup"
       id="transactionDetailsAch_transferAmount" class="big-bottom-spacer">
     </mm-amount-field>
     <mm-amount-field *ngIf="isRecurringAch && !(isIra && isIncoming)" [parentForm]="StandingAuthDetailsFormGroup"
       [maxTransferAmount]="this.maxTransferAmount$ | async" id="transactionDetailsAch_transferAmount" class="big-bottom-spacer">
     </mm-amount-field>
    <mm-amount-type-selector *ngIf="displayTaxwithholdingsFields && isRecurringAch" [parentForm]="StandingAuthDetailsFormGroup"
    [controlDisabled]="isNraAccount" [prefilledValue]="(amountType$ | async)!" [achOnRequest]="!isRecurringAch" class="big-bottom-spacer"
    [grossNetRadioEditContainer]="true" [distributionReason$]="distributionReason$"></mm-amount-type-selector>
  </div>

  <mm-amount-type-selector *ngIf="displayDetachedAmountType" id="transactionDetailsAch_amountTypeSelector" data-testid="transactionDetailsAch_amountTypeSelector"
  [parentForm]="StandingAuthDetailsFormGroup" [isDetached]="!isRecurringAch" [prefilledValue]="(amountType$ | async)!" [distributionReason$]="distributionReason$">
  </mm-amount-type-selector>

  <hr *ngIf="displayTaxwithholdingsFields">
  <mm-sa-ach-tax-withholdings *ngIf="displayTaxwithholdingsFields" [parentForm]="standingAuthorizationDetailsGroup"
  [taxWithholdings]="taxWithHolding" [taxWithholdingsFormGroupDetails]="taxWithholdingsFormGroupDetails" data-testid="standingAuthACHTaxWithholdings"
  class="big-bottom-spacer" [isRecurring]="isRecurringAch"></mm-sa-ach-tax-withholdings>

  <mm-sa-ach-contribution-reason *ngIf="showContributionReason" [parentForm]="StandingAuthDetailsFormGroup"
  [contributionOptions$]="contributionOptions$" class="big-bottom-spacer select-dropdown">
  </mm-sa-ach-contribution-reason>

</form>
